import { Component, HostBinding } from '@angular/core';

@Component({
	moduleId: module.id,
	selector: 'footer-cmp',
	templateUrl: 'footer.component.html'
})
export class FooterComponent {
	test: Date = new Date();
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/shared/footer/footer.component.ts